import CatastroTemplate from '../../components/Templates/Catastro/CatastroTemplate';
/**
 * @page Catastro.tsx
 * @description Main catastro page.
 * @return { page }
 */
function Catastro() {
  return <CatastroTemplate />;
}
export default Catastro;
